import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { approveInvite, getInvites, sendInvite } from './service';
import {
	getInvitesSuccessAction,
	getInvitesFailureAction,
	sendInviteSuccessAction,
	sendInviteFailureAction,
} from './action';

export function* getInvitesSaga() {
	try {
		const { data }: AxiosResponse = yield getInvites();
		yield put(getInvitesSuccessAction(data.data));
	} catch (e) {
		yield put(getInvitesFailureAction(e as Error));
	}
}

export function* sendInviteSaga(action: any) {
	const { email } = action.payload;
	try {
		yield sendInvite(email);
		yield put(sendInviteSuccessAction());
	} catch (e) {
		yield put(sendInviteFailureAction(e as Error));
	}
}

export function* approveInviteSaga(action: any) {
	const { email } = action.payload;
	try {
		yield approveInvite(email);
		yield put(sendInviteSuccessAction());
	} catch (e) {
		yield put(sendInviteFailureAction(e as Error));
	}
}
